import { connect } from 'react-redux';
import PatientRescheduledInformationDialog from '../../../components/Patients/Patient/PatientRescheduledInformationDialog';
import { hideDialog } from '../../../actions/uiElements';

const mapStateToProps = ({ entities: { treatmentInstances }, uiElements: { dialogs } }) => {
  const { isFetching, rescheduledInfo } = treatmentInstances.previewedRescheduledInformation;
  return {
    isFetching,
    rescheduledInfo,
    dialogs,
  };
};

const mapDispatchToProps = dispatch => ({
  hide: id => dispatch(hideDialog(id)),
});

const PatientRescheduledInformationDialogContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PatientRescheduledInformationDialog);

export default PatientRescheduledInformationDialogContainer;
